import type { ScaleThreshold, ScaleQuantize } from 'd3-scale';

import { getTokenComputedStyle } from '../../core/utils/getTokenComputedStyle.js';
import type { RangeLegendColorMap } from '../types/internal.js';

/**
 * Function to map clusters or nodes to color tokens
 * @returns - LegendColorMap
 * @param scale -
 * @param min -
 * @param max -
 * @param hasCustomRanges -
 */
export const getRangeLegendColorMap = (
  scale: ScaleQuantize<string, never> | ScaleThreshold<number, string>,
  min: number,
  max: number,
  hasCustomRanges: boolean,
) => {
  const legendColorMap = new Map() as RangeLegendColorMap;

  const ranges = hasCustomRanges
    ? scale.domain()
    : [min, ...(scale as ScaleQuantize<string, never>).thresholds(), max];

  for (let i = 0; i < ranges.length - 1; i++) {
    const mapKey = { from: ranges[i], to: ranges[i + 1] };
    const colorToken = { Default: getTokenComputedStyle(scale(ranges[i])) };
    legendColorMap.set(mapKey, { color: colorToken });
  }

  return legendColorMap;
};
